import { getValueFromEnv, isEmpty } from '@tekion/tap-components/utils/commonHelper';
import CookieHelper from '@tekion/tap-components/utils/CookieHelper';
import { sanitizeUrl } from '@tekion/tap-components/utils/helper';
import TokenManager from '@tekion/tap-components/utils/TokenManager';
import { useEffect } from 'react';
import JwtDecode from 'jwt-decode';
import { authenticateOKTAUser } from '../../api/urls';
import { getLandingPageUrl } from '../../utils/helper';

const { BASE_URL } = process.env;

const DuoAuthCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash?.substring(1));
    const loginDefaultTenantName = getValueFromEnv('LOGIN_DEFAULT_TENANT_NAME');
    const loginDefaultTenantID = getValueFromEnv('LOGIN_DEFAULT_TENANT_ID');
    const accessToken = params.get('access_token');
    const userObject = JwtDecode(accessToken);
    const { sub: email } = userObject;
    const userEmail = email && email.toLowerCase();
    const redirectUrl = params.get('redirect') || getLandingPageUrl();
    let headers = {};
  
    if (!isEmpty(loginDefaultTenantName) || !isEmpty(loginDefaultTenantID)) {
      headers['x-tenant-name'] = loginDefaultTenantName;
      headers['x-tenant-id'] = loginDefaultTenantID;
      headers['Content-Type'] = 'application/json; charset=UTF-8';
      headers['email'] = userEmail;

      TokenManager.setItemInSession(TokenManager.tenantCodeKey, loginDefaultTenantName);
      TokenManager.setItemInSession(TokenManager.tenantIdKey, loginDefaultTenantID);
    }

    CookieHelper.setCookie('tap_login_redirect_uri', sanitizeUrl(redirectUrl));
    CookieHelper.setCookie('login_type', 'okta-saml');

    const options = {
      authenticateApiUrl: authenticateOKTAUser,
      redirectUrl: redirectUrl || getLandingPageUrl(),
      authenticateApiHeaders: headers,
    };
    TokenManager.persistUserAuth({
      accessToken: {
        accessToken
      }
    }, options);
  }, []);

  return null;
}

export default DuoAuthCallback;
